import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class Weather extends Vue {

    @Prop()
    currentActiveImageIndex!: number;

    location: string = 'https://api.openweathermap.org/data/2.5/';
    apiKey: string = '6f9d7a0f8b51084f298b044362673976';
    query: string = 'rotterdam';
    weather: any =
    {
        main: {temp: 4.74},
        name: "Rotterdam",
        weather: [{id: 804, description: "overcast clouds", icon: "04d"}]
    }

    get weatherIcon(): any
    {
        return {
            ['owf owf-' + this.weather.weather[0].id as string]: true,
            'weather__icon--one': this.currentActiveImageIndex === 0,
            'weather__icon--two': this.currentActiveImageIndex === 1,
            'weather__icon--three': this.currentActiveImageIndex === 2,
            'weather__icon--four': this.currentActiveImageIndex === 3
        }
    }

    async created(): Promise<void>
    {
        await this.getWeather();
    }
    
    async getWeather(): Promise<any>
    {
        await fetch(`${this.location}weather?q=${this.query}&units=metric&APPID=${this.apiKey}`)
            .then(res => {
                return res.json();
            }).then(this.setResults);
    }

    setResults(results: any) 
    {
        this.weather = results;
    }
}
